import algoliasearch from 'algoliasearch/lite';

export const algoliaClient = algoliasearch(process.env.ALGOLIA_CONFIG_APP_ID, process.env.ALGOLIA_CONFIG_API_KEY);
